<template>
    <div class="choose_date_range_wrapper" v-click-outside="closeCalendar">
        <span class="choose_date_range" @click="toggleCalendar">
            <div style="display: grid; grid-template-columns: auto 30px;">
                <div>
                    <template v-for="period, periodIndex in titlePeriodsList">
                        <template v-if="periodIndex == 0">
                            {{period.start | formatFullDate}} - {{period.end | formatFullDate}} <br/>
                        </template>
                        <template v-else>
                            <div class="small">vs {{period.start | formatFullDate}} - {{period.end | formatFullDate}}</div>
                        </template>
                    </template>
                </div>
                <i class="arrow-drop-down"></i>
            </div>
        </span>
        <div class="calendar-wrapper" v-show="showCalendar">
            <div v-bind:class="['calendar-options-wrapper', 'selected-period-' + selectedPeriodIndex]">
                <template v-if="this.$md.mobile() !== null">
                    <div class="mobile-close-wrapper">
                        <i class="close" @click="cancelChanges"></i>
                        <span>Date Range</span>
                        <span class="save" @click="applyChanges">Save</span>
                    </div>
                </template>
                <div class="date_range_option" @click="selectDateRange(null)" v-bind:class="{active: selectedOption == null}">Custom</div>
                <div class="delimiter"></div>
                <div class="date_range_option" @click="selectDateRange('today')" v-bind:class="{active: selectedOption == 'today'}">Today</div>
                <div class="date_range_option" @click="selectDateRange('yesterday')" v-bind:class="{active: selectedOption == 'yesterday'}">Yesterday</div>
                <div class="date_range_option" @click="selectDateRange('week')" v-bind:class="{active: selectedOption == 'week'}">This week</div>
                <div class="date_range_option" @click="selectDateRange('last week')" v-bind:class="{active: selectedOption == 'last week'}">Last week</div>
                <div class="date_range_option" @click="selectDateRange('month')" v-bind:class="{active: selectedOption == 'month'}">This month</div>
                <div class="date_range_option" @click="selectDateRange('last month')" v-bind:class="{active: selectedOption == 'last month'}">Last month</div>
                <div class="delimiter"></div>
                <div class="date_range_option" @click="selectDateRange('days up to date')" v-bind:class="{active: selectedOption == 'days up to date'}">
                    <input v-model="upToToday" class="date-range-option-input">
                    <span>days up to today</span>
                </div>
                <div class="date_range_option" @click="selectDateRange('days up to yesterday')" v-bind:class="{active: selectedOption == 'days up to yesterday'}">
                    <input v-model="upToYesterday" class="date-range-option-input">
                    <span>days up to yesterday</span>
                </div>
                <template v-if="excludable">
                    <div class="date_range_option">
                        <CCSwitchToggle @toggle="excludeYesterdayAction" :checked="yesterdayExcluded" textBefore="Exclude yesterday" style="display: flex;justify-content: space-between;"></CCSwitchToggle>
                    </div>
                    <div class="date_range_option">
                        <CCSwitchToggle @toggle="toggleExcludeMode" textBefore="Exclude custom date" :checked="excludeMode" style="display: flex;justify-content: space-between;"></CCSwitchToggle>
                    </div>
                </template>
                <template v-if="comparable">
                    <div class="delimiter"></div>
                    <div class="date_range_option">
                        <CCSwitchToggle @toggle="compareDatesAction" textBefore="Compare" style="display: flex;justify-content: space-between;" :checked="compareDates === true"></CCSwitchToggle>                    
                    </div>
                </template>
            </div>
            <div class="calendar-main">
                <div class="calendar-header">
                    <div class="selectedRange">
                        <template v-for="period, periodIndex in periodsList ">
                            <div class="vs-wrapper" v-if="periodIndex > 0">
                                <span>VS</span>
                            </div>
                            <div 
                                v-bind:class="['period-line', 'period-index-' + periodIndex, {'period-active': selectedPeriodIndex === periodIndex}, ]"
                                @click="selectPeriodIndex(periodIndex)"
                            >
                                <span 
                                    @click="setSelectedPeriodPart('start')"
                                    v-bind:class="[
                                        'period-date',
                                        {'active' : selectedPeriodIndex === periodIndex && selectedPeriodPart === 'start' }
                                    ]" 
                                >
                                    {{period.start | formatFullDate}}
                                </span>
                                <span class="period-line-delimeter">&#8212;</span>
                                <span 
                                    @click="setSelectedPeriodPart('end')"
                                    v-bind:class="[
                                        'period-date',
                                        {'active' : selectedPeriodIndex === periodIndex && selectedPeriodPart === 'end' }
                                    ]" 
                                >
                                    {{period.end | formatFullDate}}
                                </span>
                            </div>                            
                        </template>
                    </div>
                    <div class="calendar-month-picker">
                        <div class="prevMonth" @click="showPrevMonth">
                            <i class="arrow-left"></i>
                        </div>
                        <span style="text-align: center;">
                            <span @click="toggleMonthesList" style="cursor: pointer;">
                                {{monthesList[0] | formatMonth}}, {{monthesList[0] | formatYear}}
                            <template v-if="isShowMonthesList">
                                <i class="arrow-top"></i>
                            </template>
                            <template v-else>
                                <i class="arrow-bottom"></i>
                            </template>
                            </span>
                        </span>
                        <div class="nextMonth" @click="showNextMonth">
                            <i class="arrow-right"></i>
                        </div>
                    </div>
                    <div class="weekDays">
                    <span v-for="weekDay in currentWeekDays">
                        {{weekDay}}
                    </span>
                    </div>
                    <div class="delimiter"></div>
                    <div class="monthes-list-wrapper" v-show="isShowMonthesList">
                        <template v-for="year in yearsList">
                            <div class="monthes-list-header">{{year | formatYear}}</div>
                            <div class="monthes-list">
                                <template v-for="month in monthesNames">
                                    <div @click="useMonth(month, year)">{{month}}</div>
                                </template>
                            </div>
                        </template>                        
                    </div>                    
                    <template v-for="month in monthesList">
                        <div style="text-align: center;margin-bottom: 15px;">
                            {{month| formatMonth}}, {{month | formatYear}}
                        </div>
                        <div class="monthDays">
                            <div class="day day-offset" v-for="offset in offsetWeekDaysInMonth(month)">
                                <span class="date"></span>
                            </div>
                        
                            <template v-for="(days, week) in daysInMonth(month)">
                                <div v-for="day in days" 
                                    @click="event => clickOnDate(event, day)" 
                                    class="day"
                                >                                    
                                    <span class="date">{{day | formatShortDate}}</span>
                                    <template v-for="className in dateClasses(day)">
                                        <div v-bind:class="['day-backend', className]">
                                            <span class="date">{{day | formatShortDate}}</span>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>                    
                </div>
            </div>
            <div class="control-buttons-wrapper">
                <div class="control-wrapper">
                    <div style="margin-right: 15px;margin-bottom: 10px;">
                        <button class="cancel-action" @click="cancelChanges">Cancel</button>
                    </div>
                    <div> 
                        <button class="apply-action" @click="applyChanges">Apply</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment';
    import _ from 'lodash';
    import 'keen-ui/src/bootstrap';
    import CCSwitchToggle from '@/components/common/switcher/v1/Switcher';
    import {dateFormatDefault} from "@/helpers/format";

    

    export default {
        name: "cc-calendar",
        components: {
            CCSwitchToggle
        },
        props: {
            periods: {
                type: Array,
                required: false,
                default: () => []
            },

            comparable: {
                type: Boolean,
                required: false,
                default: () => false
            },

            excludable: {
                type: Boolean,
                required: false,
                default: () => false
            }

        },
        data() {
            return {
                showCalendar: false,                
                upToToday: 30,
                upToYesterday: 30,
                periodsList: [],
                titlePeriodsList: [],
                selectedPeriodIndex: 0,
                selectedPeriodPart: 'start',
                selectedPeriodOption: [],
                firstMonthInMonthesList: moment(),
                isShowMonthesList: false,
                excludeModes:[]
            };
        },

        created() {
            this.init();
        },

        filters: {

            formatFullDate: function(date) {
                return typeof date === 'object' ? date.format(dateFormatDefault()) : null;
            },

            formatShortDate: function(date) {
                return typeof date === 'object' ? date.format('D') : null;
            },

            formatMonth: function(date) {
                return typeof date === 'object' ? date.format('MMM') : null;
            },

            formatYear: function(date) {
                return typeof date === 'object' ? date.format('YYYY') : null;
            }
        },

        watch: {
            periods: {
                handler: function() {
                    this.init();
                }
            },
            deep: true,

            periodsList: {
                handler: function() {
                    let self = this;
                    this.periodsList.map(function(period, index){
                        let excluded = self.getExcludedDates(index);
                        excluded = excluded.filter(date => date.isBetween(period.start, period.end, 'day', '[]'))                       
                        self.periodsList[index].excluded = excluded;
                        if( excluded.length ) {
                            self.$set(self.excludeModes, index, true);
                        }
                    })
                }
            },
            deep: true
        },

        computed: {

            excludeMode: function() {
                return this.excludeModes[this.selectedPeriodIndex] || false;
            },

            yesterdayExcluded: function() {
                let yesterday = moment().add(-1, 'day');
                let result = this.excludedDates.some(function(date){
                    return yesterday.format('YYYY-MM-DD') === date.format('YYYY-MM-DD')
                });
                return result;
            },
            
            compareDates: function() {
                return this.periodsList.length > 1;
            },
            
            monthesList: function() {
                return [ 
                    this.firstMonthInMonthesList.clone(),
                    this.firstMonthInMonthesList.clone().add(+1, 'month')
                ];
            },

            currentWeekDays: function(){
                return moment.weekdaysShort();
            },

            selectedOption: function() {
                return this.selectedPeriodOption[this.selectedPeriodIndex] || null;
            },
            
            excludedDates: function() {
                return this.getExcludedDates(this.selectedPeriodIndex);
            },

            monthesNames: function(){
                return moment.monthsShort();
            },

            yearsList: function() {
                return [
                    this.firstMonthInMonthesList.clone().add(-1, 'year'),
                    this.firstMonthInMonthesList.clone(),
                    this.firstMonthInMonthesList.clone().add(1, 'year'),
                ];
            }
        },

        methods: {

            init() {
                this.selectedPeriodIndex = 0;
                this.periodsList = _.cloneDeep(this.periods);
                if( this.periodsList.length == 0 ) {
                    this.selectDateRange('yesterday');
                }
                this.titlePeriodsList = _.cloneDeep(this.periodsList);
                this.firstMonthInMonthesList = this.periodsList[0].start.clone();
            },

            cancelChanges() {
                //this.init();
                this.showCalendar = false;
            },

            getExcludedDates(index) {
                let period = this.periodsList[index] || {};
                return  _.isArray(period.excluded) ? period.excluded : [];
            },

            applyChanges() {
                let periods = _.cloneDeep(this.periodsList);
                this.titlePeriodsList = _.cloneDeep(this.periodsList);
                this.$emit('apply', periods);
                this.showCalendar = false;
            },

            toggleExcludeMode() {
                this.$set(this.excludeModes, this.selectedPeriodIndex, !this.excludeMode);
                if( !this.excludeMode ) {
                    this.toggleExcluded('EXCLUDE_ALL');
                }
            },

            excludeYesterdayAction() {
                this.toggleExcluded(moment().add(-1, 'day'));
            },

            useMonth(month, year) {
                this.firstMonthInMonthesList = year.clone().month(month);
                this.isShowMonthesList       = false;
            },

            toggleMonthesList() {
                this.isShowMonthesList = !this.isShowMonthesList;
            },
            
            compareDatesAction(status) {
                if( status !== true ) {
                    this.periodsList = [ this.periodsList[0] ];
                    this.selectedPeriodIndex = 0;
                } else {
                    this.addDateRange('yesterday');
                }
            },
            
            setSelectedPeriodPart(part) {
                this.selectedPeriodPart = part;
            },

            toggleExcluded(date) {

                let excluded  = _.cloneDeep(this.excludedDates);

                if( date === 'EXCLUDE_ALL' ) {
                    excluded = [];
                } else {

                    let contains  = excluded.some(function(eDate){
                        return date.format('YYY-MM-DD') === eDate.format('YYY-MM-DD');
                    });

                    if( contains ) {
                        excluded = excluded.filter(function(eDate) {
                            return eDate.format('YYY-MM-DD') !== date.format('YYY-MM-DD');
                        });
                    } else {
                        excluded.push(date);
                    }
                }

                let period = _.assign(this.periodsList[this.selectedPeriodIndex], {excluded : excluded});
                this.$set(this.periodsList, this.selectedPeriodIndex, period);
            },
            
            clickOnDate(event, date) {

                if( this.excludable === true && ( event.ctrlKey === true || this.excludeMode === true ) ) {
                    this.toggleExcluded(date);
                    return;
                }

                if( event.ctrlKey === true ) {
                    return;
                }

                let period = _.cloneDeep(this.periodsList[this.selectedPeriodIndex]);
                let start  = period.start;
                let end    = period.end;
                if( this.selectedPeriodPart === 'end' && date.isBefore(start.format('YYYY-MM-DD')) ) {
                    this.selectedPeriodPart = 'start';
                }

                // if( this.selectedPeriodPart === 'start' && end.isBefore(date.format('YYYY-MM-DD')) ) {
                //     this.selectedPeriodPart = 'end';
                // }

                if( this.selectedPeriodPart === 'start' ) {
                    period.start = date.clone();
                    period.end   = date.clone();
                } else {
                    period[this.selectedPeriodPart] = date.clone();
                }

                this.selectedPeriodPart = (this.selectedPeriodPart === 'start') ? 'end' : 'start'; 
                this.$set(this.selectedPeriodOption, this.selectedPeriodIndex,  null);
                this.$set(this.periodsList, this.selectedPeriodIndex,  period);
            },

            dateClasses(date) {
                let hIndices = [];
                let sIndices = [];
                let eIndices = [];

                let indices = {};
                let multiple = 0;
                for( let index = 0; index < this.periodsList.length; index++ ) {
                    let prefixes = [];

                    let period = this.periodsList[index];
                    if (date.isBetween(period.start, period.end, 'day', '[]')) {
                        prefixes.push('highlighted');
                    }

                    if (date.isSame(period.start, 'day')) {
                        prefixes.push('start');
                    }

                    if (date.isSame(period.end, 'day')) {
                        prefixes.push('end');
                    }

                    if( _.isArray(period.excluded) ) {
                        period.excluded.map(function(excludedDate){
                            if (date.isSame(excludedDate, 'day')) {
                                prefixes.push('excluded');
                            }
                        });
                    }

                    if( prefixes.length > 0 ) {
                        indices[index] = prefixes;
                        multiple++;
                    }
                }

                let classes = [];
                for( let index in indices ) {
                    let prefixes = indices[index];
                    let classList = [];
                    prefixes.map(function(prefix){
                        classList.push(prefix);
                        classList.push(prefix + '-' + index);
                    })

                    if( multiple > 1 ) {
                        classList.push('multiple multiple-' + index);
                    }

                    classes.push(classList.join(' '));
                }   

                return classes;
            },

            showNextMonth() {
                this.firstMonthInMonthesList = this.firstMonthInMonthesList.clone().add(+1, 'month');
            },

            showPrevMonth() {
                this.firstMonthInMonthesList = this.firstMonthInMonthesList.clone().add(-1, 'month');
            },

            selectPeriodIndex: function(index) {
                this.selectedPeriodIndex = index;
            },

            daysInMonth: function(month){
                let startDateInMonth = month.startOf('month').clone();
                let endDateInMonth   = month.endOf('month').clone();

                let dates = [];
                var index = startDateInMonth.clone().add(-1, 'day');
                while(index.isBefore(endDateInMonth, 'day')) {
                    dates.push(new Array(7).fill(0).map(() => index.add(1, 'day').clone()));
                }                
                return dates.map(week => week.filter(date => date.isSameOrBefore(endDateInMonth, 'day')));
            },

            offsetWeekDaysInMonth(month) {
                return month.startOf('month').day();
            },

            addDateRange(periodName) {
                this.selectedPeriodIndex++;
                this.$set(this.selectedPeriodOption, this.selectedPeriodIndex, periodName);
                let period = this.makePeriod(periodName);
                period = _.assign(this.periodsList[this.selectedPeriodIndex], period);
                this.$set(this.periodsList, this.selectedPeriodIndex, period);
            },            

            selectDateRange(periodName) {
                this.$set(this.selectedPeriodOption, this.selectedPeriodIndex, periodName);
                let period = this.makePeriod(periodName);
                period = _.assign(this.periodsList[this.selectedPeriodIndex], period);
                this.$set(this.periodsList, this.selectedPeriodIndex, period);
            },

            toggleCalendar() {
                this.showCalendar = !this.showCalendar;
            },

            closeCalendar() {
                this.showCalendar = false;
            },

            makePeriod: function(periodName)
            {
                switch(periodName) {
                    case 'today':
                        return {
                            start: moment(),
                            end: moment(),
                        }
                        break;

                    case 'yesterday':
                        return {
                            start: moment().add(-1, 'day'),
                            end: moment().add(-1, 'day')
                        }
                        break;

                    case 'week':
                        return {
                            start: moment().startOf('week'),
                            end: moment().endOf('week')
                        }
                        break;

                    case 'last week':
                        return {
                            start: moment().add(-1, 'week').startOf('week'),
                            end: moment().add(-1, 'week').endOf('week')
                        }
                        break;

                    case 'month':
                        return {
                            start: moment().startOf('month'),
                            end: moment().endOf('month')
                        }
                        break;

                    case 'last month':
                        return {
                            start: moment().add(-1, 'month').startOf('month'),
                            end: moment().add(-1, 'month').endOf('month')
                        }
                        break;

                    case 'days up to date':
                        return {
                            start: moment().add( - this.upToToday, 'day'),
                            end: moment()
                        }
                        break;
                    
                    case 'days up to yesterday':
                        return {
                            start: moment().add( - this.upToYesterday, 'day'),
                            end: moment().add(-1, 'day')
                        }
                        break;
                    
                    default: 
                        return {
                            start: moment().add(-1, 'day'),
                            end: moment().add(-1, 'day')
                        }
                        break;
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "./style.scss";
</style>


// WEBPACK FOOTER //
// src/components/common/calendar/v2/Calendar.vue